import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { LocationState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): LocationState => state.location,
);

export default selectors;
